var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 36.9V12.3C1.53333 12.2333 1.08333 11.9 0.65 11.3C0.216667 10.7 0 10.05 0 9.35V3C0 2.23333 0.3 1.54167 0.9 0.925C1.5 0.308334 2.2 0 3 0H37C37.7667 0 38.4583 0.308334 39.075 0.925C39.6917 1.54167 40 2.23333 40 3V9.35C40 10.05 39.7833 10.7 39.35 11.3C38.9167 11.9 38.4667 12.2333 38 12.3V36.9C38 37.6667 37.6917 38.375 37.075 39.025C36.4583 39.675 35.7667 40 35 40H5C4.2 40 3.5 39.675 2.9 39.025C2.3 38.375 2 37.6667 2 36.9ZM5 12.35V37H35V12.35H5ZM37 9.35V3H3V9.35H37ZM14 22.85H26V19.85H14V22.85ZM5 37V12.35V37Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.07f8b788300198d7216afd0bd096bdf5.svg";
export { ForwardRef as ReactComponent };